import UploadLimitsData from "../interfaces/UploadLimitsData";

export default function decodeUploadLimitsData(data: string): UploadLimitsData {
    const parsed = JSON.parse(data);
    if (!parsed) throw new SyntaxError("Incorrect format");
    return {
        date: new Date(parsed.date) || new Date().toISOString().split('T')[0],
        uploads: parsed.uploads || 0,
    }
}